import React from "react";
import SEO from "../components/SEO";
import LegalPage, { H2, P, UL } from "../components/LegalPage";

/**
 * What this site actually does with data — not a template.
 *
 * Every claim here is checked against the code: the enquiry form posts to
 * Formspree, the visit counter is the cookieless one, the fonts come from
 * Google, and nothing writes to the browser. If any of those change, this page
 * is wrong and has to change with them.
 */

export default function PrivacyPage() {
  return (
    <>
      <SEO
        title="Privacy Policy | D, Trio Trek"
        description="What D, Trio Trek collects when you enquire, who it passes through, and how long it is kept."
      />
      <LegalPage title="Privacy Policy" updated="August 2026">
        <P>
          This site is run by D, Trio Trek, Skardu and Islamabad, Pakistan. It
          explains what we collect, why, and who else sees it. If anything here
          is unclear, email{" "}
          <a href="mailto:dtriotrek@gmail.com" className="underline">dtriotrek@gmail.com</a>{" "}
          and ask.
        </P>

        <H2>When you send an enquiry</H2>
        <P>
          The contact form asks for your name, email address, which tour you are
          interested in, your message, and optionally a phone number. We use it
          for one thing: to answer you and plan the trip. We do not sell it, and
          we do not add you to a mailing list from it.
        </P>
        <P>
          The form is delivered by <strong>Formspree</strong>, a third-party form
          service, which receives what you type and forwards it to our email.
          That means your enquiry passes through their servers, which are outside
          Pakistan. Their privacy terms are at{" "}
          <a href="https://formspree.io/legal/privacy-policy" target="_blank" rel="noreferrer" className="underline">
            formspree.io/legal/privacy-policy
          </a>
          . If you would rather not use it, email or WhatsApp us directly — the
          address and number are on the contact page.
        </P>

        <H2>When you just read the site</H2>
        <P>
          We count visits so we know whether the site is doing anything. The way
          it counts matters, so plainly:
        </P>
        <UL items={[
          "No cookies are set. Nothing is written to your browser by this site, which is why there is no cookie banner.",
          "No IP address is stored. One is used for a moment to tell two visitors apart on the same day, hashed with a key that is thrown away every night — so nobody can follow you from one day to the next, including us.",
          "We keep counts, not visits. A date, a page, a number. There is no record of your individual visit to hand over or leak.",
          "The page you landed on, the site that linked you, your country, your device type and roughly how long you stayed are counted in aggregate.",
        ]} />

        <H2>Other people's servers</H2>
        <P>
          Two things load from elsewhere and will therefore see your IP address,
          as they would on almost any site: the typefaces come from Google Fonts,
          and the site itself is hosted on Cloudflare Pages. Neither is given any
          information about you by us.
        </P>

        <H2>How long we keep things</H2>
        <P>
          Enquiries stay in our email while we are talking to you and for as long
          as we may need them for a booking — after that we delete them on
          request. Visit counts are aggregate numbers with nothing personal in
          them and are kept indefinitely.
        </P>

        <H2>Asking us to delete something</H2>
        <P>
          Email{" "}
          <a href="mailto:dtriotrek@gmail.com" className="underline">dtriotrek@gmail.com</a>{" "}
          and we will remove your enquiry and any correspondence. We cannot
          remove you from the visit counts, because there is nothing in them that
          identifies you to remove.
        </P>
      </LegalPage>
    </>
  );
}
